import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef, GridRowModel, GridRowModesModel } from '@mui/x-data-grid';
import { FGrid } from '../grid';

type Props = { rows: any[]; loading?: boolean; onChange: (rows: any[]) => void; onSave: (rows: any[]) => Promise<void> };
type State = { rowModesModel: GridRowModesModel; saving: boolean };

class SimulationAssumptionsGrid extends React.Component<Props, State> {
  state: State = { rowModesModel: {}, saving: false };
  getRowId = (r: any) => r.id || r.rid || r.assumptionid || r.code || r.shortcode;

  columns: GridColDef[] = [
    { field: 'category', headerName: 'Category', width: 150 },
    { field: 'code', headerName: 'Code', width: 150 },
    { field: 'name', headerName: 'Assumption', flex: 1, minWidth: 260 },
    { field: 'sourceclass', headerName: 'Source Class', width: 160 },
    { field: 'sourcechannel', headerName: 'Source Channel', width: 160 },
    { field: 'value', headerName: 'Value', width: 140, type: 'number', editable: true },
    { field: 'unit', headerName: 'Unit', width: 100 },
    { field: 'confidence', headerName: 'Confidence', width: 120, type: 'number' },
    { field: 'required', headerName: 'Required', width: 120, renderCell: (p) => <Chip size="small" label={p.value ? 'Yes' : 'No'} color={p.value ? 'success' : 'default'} /> },
    { field: 'status', headerName: 'Status', width: 120, renderCell: (p) => <Chip size="small" label={p.value || '-'} color={p.value === 'READY' ? 'success' : 'warning'} /> },
  ];

  processRowUpdate = (newRow: GridRowModel) => {
    const id = this.getRowId(newRow);
    const rows = (this.props.rows || []).map((r: any) => String(this.getRowId(r)) === String(id) ? { ...r, ...newRow, _state: r.rid ? 'dirty' : 'new' } : r);
    this.props.onChange(rows);
    return newRow;
  };

  saveAll = async () => {
    this.setState({ saving: true });
    try { await this.props.onSave(this.props.rows || []); }
    finally { this.setState({ saving: false }); }
  };

  render() {
    return (
      <FGrid
        title="Scenario Assumptions"
        subtitle="Review assumption sources, confidence and editable planning values."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading || this.state.saving}
        height={520}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#e7f6ea' }}
        getRowId={this.getRowId}
        editMode="row"
        rowModesModel={this.state.rowModesModel}
        onRowModesModelChange={(model: GridRowModesModel) => this.setState({ rowModesModel: model })}
        processRowUpdate={this.processRowUpdate}
        onProcessRowUpdateError={(err: any) => console.error(err)}
        saveAll={this.saveAll}
        pageSizeOptions={[10, 25, 50]}
      />
    );
  }
}
export default SimulationAssumptionsGrid;
